import { render, staticRenderFns } from "./TemplateAIRClient.vue?vue&type=template&id=31e73b04&scoped=true&"
import script from "./TemplateAIRClient.vue?vue&type=script&lang=js&"
export * from "./TemplateAIRClient.vue?vue&type=script&lang=js&"
import style0 from "./TemplateAIRClient.vue?vue&type=style&index=0&id=31e73b04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e73b04",
  null
  
)

export default component.exports